// extracted by mini-css-extract-plugin
module.exports = {"accordionContent":"Accordion_accordionContent__iJJsD","header":"Accordion_header__fE56u","item":"Accordion_item__0_9YI","expanded":"Accordion_expanded__oa4YP"};